export default "__VITE_PUBLIC_ASSET__ce4a05d8__"